module.exports = __webpack_public_path__ + "media/images/home/caviar-978b346199817dadb14782b815d052ba.png";